import { render, staticRenderFns } from "./s1-2.vue?vue&type=template&id=4ba26c94&scoped=true&"
import script from "./s1-2.vue?vue&type=script&lang=js&"
export * from "./s1-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba26c94",
  null
  
)

export default component.exports